import React, {Component} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {CancelToken} from '../../../../../libs/shared/core/src/helpers/utilities/asyncCancelHelpers';
import {CompanyModel} from '../../../../../libs/shared/core/src/models/api/company/companyModel';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {
  AsyncSearchDropdown,
  AsyncSearchDropdownResponse,
} from '../../../../../libs/shared/ui/src/components/dropdowns/search/asyncSearchDropdown';
import {SearchTagModel} from '../../../../models/api/searchTagModel';
import {TagModel} from '../../../../models/api/tagModel';
import {TagDropdownItem} from '../tagDropdownItem';

/*
 * Props.
 */

type SearchTagFetcher = (
  query: string,
  data: ReadonlyArray<SearchTagModel | null>,
  cancelToken: CancelToken,
) => Promise<AsyncSearchDropdownResponse<SearchTagModel | null>>;

interface PickParentTagDropdownProps extends DropdownProps {
  company: CompanyModel;
  fetchTagsAsync: SearchTagFetcher;
  onTagSelect: (arg: SearchTagModel | undefined) => void;
  selectedTag?: TagModel;
  tag?: TagModel;
}

/*
 * Component.
 */

interface PickParentTagDropdownState {
  query: string;
}

export class PickParentTagDropdown extends Component<PickParentTagDropdownProps, PickParentTagDropdownState> {
  constructor(props: PickParentTagDropdownProps) {
    super(props);
    this.state = {query: ''};
  }

  render() {
    return (
      <AsyncSearchDropdown
        {...this.props} /* eslint-disable-line react/jsx-props-no-spreading */
        headerTitle={<Trans id="dropdown-tag-title">Tags</Trans>}
        query={this.state.query}
        onQueryChange={(newQuery) => {
          this.setState({query: newQuery});
        }}
        height={300}
        onRequestData={this.props.fetchTagsAsync}
        renderRow={this.renderRow}
      />
    );
  }

  private readonly renderRow = (
    searchTag: SearchTagModel | null,
    index: number,
    _data: ReadonlyArray<SearchTagModel | null>,
    requestQuery: string,
  ) => {
    const {onTagSelect, selectedTag} = this.props;
    const isSearching = Boolean(requestQuery);

    if (searchTag === null) {
      const isNoneChecked = this.props.selectedTag === undefined;
      return (
        <DropdownItem
          key="no-parent-tag"
          index={index}
          isChecked={isNoneChecked}
          onSelect={() => onTagSelect(undefined)}
        >
          <DropdownItemIcon label={null} iconName="noneSmall" />
          <DropdownItemContent isChecked={isNoneChecked}>
            <Trans id="dropdown-tag-noparenttag">None</Trans>
          </DropdownItemContent>
        </DropdownItem>
      );
    }

    const tag = searchTag[0];
    const isChecked = selectedTag && selectedTag.id === tag.id;
    const nestingLevel = isSearching ? 0 : searchTag.length - 1;
    const tagsPath = isSearching ? searchTag : [];

    return (
      <TagDropdownItem
        tag={tag}
        tagsPath={tagsPath}
        key={tag.id}
        index={index}
        isChecked={isChecked}
        nestingLevel={nestingLevel}
        onSelect={(e) => onTagSelect(searchTag)}
      />
    );
  };
}
